import { Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2 } from '@angular/core';


/**
 * * Diretiva para elementos com tooltip.
 *
 * Criada a partir do exemplo: https://stackblitz.com/edit/angular-tooltip-directive
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[tooltip]'
})
export class TooltipDirective implements OnDestroy {

  /**
   * * Texto do Tooltip.
   */
  @Input('tooltip') tooltipTitle!: string;
  /**
   * * Local onde o tooltip deve ser posicionado.
   */
  @Input() placement: 'top' | 'bottom' | 'left' | 'right' = 'top';
  // @Input() disabled: string;
  /**
   * * Delay para esconder o tooltip.
   */
  @Input() delay: string = '2000';

  tooltip!: HTMLElement | null;

  offset = 10;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this.tooltipTitle && this.tooltipTitle.length > 0 && !this.tooltip) {
      this.show();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (this.tooltip) {
      this.hide();
    }
  }

  ngOnDestroy(): void {
    this.onMouseLeave();
  }

  private show(): void {
    this.create();
    this.setPosition();
    this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
    setTimeout(() => this.hide(), parseInt(this.delay, 10));
  }

  private hide(): void {
    if (this.tooltip) {
      this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }
  }

  private create(): void {
    this.tooltip = this.renderer.createElement('span');

    this.renderer.appendChild(
      this.tooltip,
      this.renderer.createText(this.tooltipTitle) // textNode
    );

    this.renderer.appendChild(document.body, this.tooltip);
    // this.renderer.appendChild(this.el.nativeElement, this.tooltip);

    this.renderer.addClass(this.tooltip, 'ng-tooltip');
    this.renderer.addClass(this.tooltip, `ng-tooltip-${this.placement}`);

    // delay 설정
    this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity 3ms`);
    this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity 3ms`);
    this.renderer.setStyle(this.tooltip, '-o-transition', `opacity 3ms`);
    this.renderer.setStyle(this.tooltip, 'transition', `opacity 3ms`);
  }

  private setPosition(): void {
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    if (this.tooltip) {
      const tooltipPos = this.tooltip.getBoundingClientRect();
      const scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      let top: number = 0;
      let left: number = 0;

      switch (this.placement) {
        case 'top':
          top = hostPos.top - tooltipPos.height - this.offset;
          left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
          break;
        case 'bottom':
          top = hostPos.bottom + this.offset;
          left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
          break;
        case 'left':
          top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
          left = hostPos.left - tooltipPos.width - this.offset;
          break;
        case 'right':
          top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
          left = hostPos.right + this.offset;
          break;
      }

      this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
      this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
    }
  }

}
